import { useMutation } from '@tanstack/react-query';

import { PricingPlanPeriodAdjustment } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/pricing/pricing-plan/:planId/pricing-plan-period-adjustment/:adjustmentId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    planId: string;
    adjustmentId: string;
    parkingId: string;
}
const mutationFn = ({ planId, adjustmentId, parkingId, ...params }: DTO): Promise<PricingPlanPeriodAdjustment> => {
    return axios.put(formatResourcePath(RESOURCE, { planId, adjustmentId, parkingId }), params);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdatePricingPlanAdjustment };
